import React from "react";
import LegalDocumentPage, { type LegalSection } from "./LegalDocumentPage";

const sections: LegalSection[] = [
  {
    heading: "1. Introduction",
    paragraphs: [
      "Welcome to T-Accounts. We operate a web-based application that allows users to create and manage T-account visualizations and related accounting diagrams.",
      "This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.",
      "By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.",
    ],
  },
  {
    heading: "2. Information We Collect",
    paragraphs: ["Information You Provide", "We may collect information that you voluntarily provide when you:"],
    bullets: [
      "Create an account.",
      "Use the application.",
      "Contact support.",
      "Subscribe to paid plans.",
    ],
  },
  {
    heading: "Information We May Collect Includes",
    bullets: [
      "Name.",
      "Email address.",
      "Account login credentials.",
      "Payment information processed by third-party payment providers.",
      "Accounting data and diagrams you create within the Service.",
    ],
  },
  {
    heading: "Automatically Collected Information",
    paragraphs: ["When you use the Service, we may automatically collect information including:"],
    bullets: [
      "IP address.",
      "Browser type.",
      "Device type.",
      "Pages visited.",
      "Usage patterns.",
      "Date and time of access.",
    ],
  },
  {
    heading: "3. How We Use Your Information",
    paragraphs: ["We may use the collected information to:"],
    bullets: [
      "Provide and maintain the Service.",
      "Authenticate users.",
      "Store and display T-account diagrams and related data.",
      "Process subscriptions and payments.",
      "Improve the functionality and reliability of the Service.",
      "Respond to customer inquiries.",
      "Monitor usage and prevent abuse.",
      "Comply with legal obligations.",
    ],
  },
  {
    heading: "4. Data Storage and Security",
    paragraphs: [
      "We take reasonable measures to protect your information.",
      "These measures may include encrypted connections, secure cloud infrastructure, and access controls and authentication mechanisms.",
      "However, no method of transmission over the internet or electronic storage is completely secure.",
    ],
  },
  {
    heading: "5. Third-Party Services",
    paragraphs: ["We may use third-party services to operate the Service, including:"],
    bullets: [
      "Payment processors such as Stripe.",
      "Cloud hosting providers.",
      "Analytics services.",
      "Email delivery services.",
    ],
  },
  {
    heading: "6. User Content",
    paragraphs: [
      "The diagrams, financial information, and other content you create within the Service remain your property.",
      "We store this information solely to provide the functionality of the Service. We do not sell or publicly share your accounting data.",
    ],
  },
  {
    heading: "7. Data Retention",
    paragraphs: ["We retain your information only for as long as necessary to:"],
    bullets: [
      "Provide the Service.",
      "Maintain your account.",
      "Comply with legal obligations.",
      "Resolve disputes.",
      "Enforce agreements.",
      "Support account deletion requests.",
    ],
  },
  {
    heading: "8. Cookies and Tracking Technologies",
    paragraphs: [
      "We may use cookies or similar technologies to maintain login sessions, improve user experience, and analyze usage of the Service.",
      "You may disable cookies in your browser settings, though some features of the Service may not function properly.",
    ],
  },
  {
    heading: "9. Children's Privacy",
    paragraphs: [
      "The Service is not intended for individuals under the age of 13.",
      "We do not knowingly collect personal information from children.",
    ],
  },
  {
    heading: "10. Your Rights",
    paragraphs: ["Depending on your jurisdiction, you may have rights including:"],
    bullets: [
      "Access to your personal data.",
      "Correction of inaccurate information.",
      "Deletion of your data.",
      "Restriction of processing.",
      "Data portability.",
      "Requests can be submitted by contacting us.",
    ],
  },
  {
    heading: "11. Changes to This Privacy Policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time.",
      "When changes are made, we will update the Last Updated date and may notify users through the Service.",
    ],
  },
  {
    heading: "12. Contact Us",
    bullets: ["Email: support@t-accounts.com", "Company: JPWare LLC"],
  },
];

export default function PrivacyPolicyPage() {
  return <LegalDocumentPage title="Privacy Policy" lastUpdated="Mar. 10, 2026" sections={sections} />;
}